module.exports = __webpack_public_path__ + "static/img/jd2.a4eab8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd2.jpg
// module id = xKNm
// module chunks = 1